import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  close: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  tabData1: <PortalMessage id='t.app.results.details.tabData1' defaultMessage='Periodo 1' />,
  tabData2: <PortalMessage id='t.app.results.details.tabData2' defaultMessage='Periodo 2' />,
  period: <PortalMessage id='t.app.results.details.period' defaultMessage='Periodo di riferimento:' />,
  transactions: <PortalMessage id='t.app.results.details.transactions' defaultMessage='Transazioni' />,
  transacted: <PortalMessage id='t.app.results.details.transacted' defaultMessage='Transato' />,
  payment: <PortalMessage id='t.app.results.details.payment' defaultMessage='Pagamento' />,
  titleNavigation: <PortalMessage id='t.app.results.details.cards.titleNavigation' defaultMessage='Dettaglio provenienza carte estere' />,
  nations: <PortalMessage id='t.app.results.details.cards.nations' defaultMessage='Nazioni' />,
  foreignCards: <PortalMessage id='t.app.results.details.cards.foreignCards' defaultMessage='Carte estere' />,
  foreignCardsSubtitle: <PortalMessage id='t.app.results.details.cards.foreignCardsSubtitle' defaultMessage='I dati mostrati fanno riferimento solo alle carte estere con provenienza riconosciuta.' />
}

export default formattedMessage
